export default function Page404() {
    return (
        <main className='flex-shrink-0 modular min-vh-100'>
            <div className="text-center p-4">Page not Found</div>
            
        </main>
    )
}